import { render, staticRenderFns } from "./CadastroCotacao.vue?vue&type=template&id=ade98914&scoped=true&"
import script from "./CadastroCotacao.vue?vue&type=script&lang=ts&"
export * from "./CadastroCotacao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade98914",
  null
  
)

export default component.exports